import React from "react";
import "./header.scss";
import { CgProfile } from "react-icons/cg";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useNavigate, useLocation } from "react-router-dom";

interface HeaderProps {
  showBackLink?: boolean;
  fromProjectReadiness?: boolean;
}

const Header: React.FC<HeaderProps> = ({ showBackLink = false, fromProjectReadiness = false }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Automatically detect if this is a readiness page based on route or location state
  const isReadinessPage = 
    fromProjectReadiness || 
    location.pathname === "/project-readiness" ||
    (location.state as any)?.fromProjectReadiness === true ||
    (location.state as any)?.showProjectReadiness === true;

  const handleBackToDashboard = () => {
    if (isReadinessPage) {
      // Navigate back to Project Readiness Dashboard
      navigate("/dashboard", { state: { showProjectReadiness: true } });
    } else {
      // Navigate to normal Dashboard
      navigate("/dashboard");
    }
  };

  return (
    <div className="heading_container">
      <div className="hmain">
        <div className="left_section">
          <img src={require("../../../images/LTM.png")} alt="" />
          <div className="app_title">{isReadinessPage ? "PBT Readiness Assessment" : "PBT Assessment"}</div>
          {showBackLink && (
            <span className="back_link" onClick={handleBackToDashboard}>
              {isReadinessPage ? "← Back to Project Readiness list" : "← Back to Project list"}
            </span>
          )}
        </div>
        <div className="greet_user">
          <span>Welcome </span>
          <span>{sessionStorage.getItem("PBT_FIRSTNAME")}</span>
          <AccountCircleIcon style={{ fontSize: 36, color: "#5B5B5B" ,translate:'0px 10px'}} />
        </div>
      </div>
      <div className="underlines"></div>
    </div>
  );
};

export default Header;
